import { httpRequest } from './http';

const BACKEND_BASE = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:3001/api/v1';
const TENANT_SLUG = process.env.REACT_APP_TENANT_SLUG;

function withTenantHeaders(options = {}) {
  const headers = { ...(options.headers || {}) };
  if (TENANT_SLUG) headers['x-tenant-slug'] = TENANT_SLUG;
  return { ...options, headers };
}

function mapProduct(p) {
  if (!p) return p;
  const id = p.id || p._id;
  // Ensure a stable `id` field without duplicating keys
  return { ...p, id };
}

export const productsAPI = {
  async getAll() {
    const json = await httpRequest(BACKEND_BASE, '/products', withTenantHeaders({ method: 'GET' }));
    const items = Array.isArray(json) ? json.map(mapProduct) : [];
    return { data: items };
  },
  async getById(id) {
    const json = await httpRequest(BACKEND_BASE, `/products/${encodeURIComponent(id)}`, withTenantHeaders({ method: 'GET' }));
    return { data: mapProduct(json) };
  },
  async create(payload) {
    const json = await httpRequest(BACKEND_BASE, '/products', withTenantHeaders({ 
      method: 'POST', 
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' }
    }));
    return { data: mapProduct(json) };
  },
  async update(id, payload) {
    const json = await httpRequest(BACKEND_BASE, `/products/${encodeURIComponent(id)}`, withTenantHeaders({ method: 'PUT', body: JSON.stringify(payload) }));
    return { data: mapProduct(json) };
  },
  async delete(id) {
    await httpRequest(BACKEND_BASE, `/products/${encodeURIComponent(id)}`, withTenantHeaders({ method: 'DELETE' }));
    return { data: { success: true } };
  },
  async search(query) {
    // Optional: if backend search is not implemented, filter client-side after getAll
    const all = await this.getAll();
    const q = (query || '').toLowerCase();
    const filtered = (all.data || []).filter(p =>
      (p.name || '').toLowerCase().includes(q) ||
      (p.sku || '').toLowerCase().includes(q) ||
      (p.description || '').toLowerCase().includes(q)
    );
    return { data: filtered };
  }
};

export default productsAPI;
